module.exports = __webpack_public_path__ + "assets/default.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/default.png
// module id = f4JG
// module chunks = 1